// ADR 7.10.26w §6 — the companion's one web-minted event.
//
// `web_`-prefixed under 9.9.26m's rule for a web-only event. One per switcher
// tab press that changes the front; it carries no app id and no app name (a
// private app's name is its owner's business — 30.9.26ai §14).

import { capture } from '../../telemetry/capture'
import type { Front } from './companionFront'

const COMPANION_SWITCHED_EVENT = 'web_companion_switched'

export function companionSwitched(to: Front): void {
  capture(COMPANION_SWITCHED_EVENT, { to })
}
